<script>
  import { ItemMeta } from "../../../constants/items";
  import { SPRITES } from "../../../constants/sprites";
  import {
    GameStateStore,
    ItemsStore,
    PlayerId,
    SetupStore,
    MerchantClicked,
    MerchantTokenPosition
  } from "../../stores/gameStore";
  import ItemCard from "../ItemCard.svelte";
  import MerchantToken from "../MerchantToken.svelte";

  export let id, scale, selectable, disabled, action;

  $: item = $ItemsStore[id];
  $: merchantTokenPosition = $MerchantTokenPosition;

  function performAction (id) {
    if (!action) return;

    window.GAME.bgaPerformAction(action, {
              cardId: id,
              playerId: $PlayerId,
            });

    if (action == "merchantToken") {
      MerchantClicked.set(false);
      window.GAME.updatePageTitle();
    }       
  }

</script>

<div
  class:disabled
  class:selectable
  style:outline-color={ItemMeta[
    $SetupStore.data.cards[id].position || "UNDEFINED"
  ].color}
> 
  <div class="merchant-token-wrapper" style="position:relative; z-index: 10;">
    {#if merchantTokenPosition === id}
      <MerchantToken
      scale= {scale}
      left = 0
      top = 0
      />
    {/if}
  </div>

  <div class="item-card-wrapper" style="position:relative; z-index: 1;">
    <ItemCard
      width={SPRITES["ITEMS_FRONT"].width * scale * 0.5}
      card={$SetupStore.data.cards[id]}
      {id}
      enhanced={item.enhanced}
      location={'craftingtree'}
      onclick={selectable
        ? (e) => {
            e.preventDefault();
            performAction(id);
          }
        : undefined}
    />
  </div>
</div>

<style>
  .disabled {
    filter: saturate(0.4) brightness(0.9) contrast(0.4) sepia(0.5);
  }

  .selectable {
    outline: white solid 2px;
    outline-offset: 2px;
    border-radius: 5px;
  }
</style>
